export const SCOPE = 'aiAlerts';
export const INIT = `${SCOPE}/INIT`;
export const RESET = `${SCOPE}/RESET`;

export const FETCH_DATA = `${SCOPE}/FETCH_DATA`;
export const SET_DIAGNOSTICS_DATA = `${SCOPE}/SET_DIAGNOSTICS_DATA`;
export const FETCHING = `${SCOPE}/FETCHING`;
export const SET_ERROR = `${SCOPE}/SET_ERROR`;
export const SET_SELECTED_ALERT = `${SCOPE}/SET_SELECTED_ALERT`;
